<app-service-slider
  heading="services.popular-srvs"
  subHeading="services.popular-srvs-desc"
  srvNameKey="dis_name"
  displayKey="service_name"
  logoUrlKey="dept_img"
  srvIdKey="service_id"
  [isLoading]="isLoading"
  [services]="popularServices"
  [isPopular]="true"
></app-service-slider>
